import { createContext, useContext, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import Config from "../config/config";

const GaContext = createContext();

let gaInitialized = false;

export const GaProvider = ({ children }) => {
    const location = useLocation();
    const [ gaLoaded, setGaLoaded ] = useState(false);
    const lastPathRef = useRef(null);

    useEffect(() => {
      if (!gaInitialized) {
        ReactGA.initialize(Config.app.gaKey);
        gaInitialized = true
        setGaLoaded(true);
      }
    }, [ setGaLoaded ]);

    useEffect(() => {
        if (!gaInitialized || !gaLoaded) return;

        const currentPath = location.pathname + location.search;
        // Avoid duplicate sends (e.g., React StrictMode double renders)
        if (lastPathRef.current === currentPath) return;

        lastPathRef.current = currentPath;

        ReactGA.send({ 
          hitType: "pageview", 
          page: currentPath 
        });
    }, [ gaLoaded, location ]);
    
    const trackEvent = (eventName, params = {}) => {
        if (!gaInitialized) return;
        ReactGA.event(eventName, params);
    };

    return (
        <GaContext.Provider value={{ trackEvent }}>
          {children}
        </GaContext.Provider>
      );
}

export const useGa = () => useContext(GaContext);